export const paymentPaidConstants = 'paid'
export const paymentUnpaidConstants = 'unpaid'
export const paymentDueConstants = 'due'


export const outreachInvoiceStatusConstants = [
    { name: "Pending", value: "pending", variant: "light-primary" },
    { name: "Paid", value: "paid", variant: "light-success" },
    { name: "Due", value: "due", variant: "light-warning" }
];